import React from "react";
import HighlightedText from "./HighlightedText";
import ContextItemIdText from "./ContextItemIdText";
import DotSeparator from "../DotSeparator";

// A row's subtitle line, shared by Search's ResultRow and Browse's
// BrowseRow: free text (client/matter name, doc type, etc.) on the left,
// which ellipsizes first if the row is too narrow, then the row's ID text
// on the right, which never shrinks or clips — a long name shouldn't be
// able to wrap the row onto a second line, or crowd out/cut into the
// ID(s) that actually matter for filtering and searching.
const RowSubtitle = ({ text, item, highlightQuery }) => (
	<div style={{ display: "flex", minWidth: 0 }}>
		{text ? (
			<span
				style={{
					minWidth: 0,
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				<HighlightedText text={text} query={highlightQuery} />
			</span>
		) : null}
		<span style={{ flexShrink: 0, whiteSpace: "nowrap" }}>
			{text ? <DotSeparator /> : null}
			<ContextItemIdText item={item} highlightQuery={highlightQuery} />
		</span>
	</div>
);

export default RowSubtitle;
